import { render } from "./SiteMenu.vue?vue&type=template&id=4148ec7b&scoped=true"
import script from "./SiteMenu.vue?vue&type=script&lang=js"
export * from "./SiteMenu.vue?vue&type=script&lang=js"

import "./SiteMenu.vue?vue&type=style&index=0&id=4148ec7b&lang=scss&scoped=true"

import exportComponent from "/var/www/vhosts/t-socialposterexpertise-240125/project/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4148ec7b"]])

export default __exports__